import { Injectable } from '@angular/core';

// Services
import { GroupService } from './group.service';

// RxJS
import { map, Observable } from 'rxjs';

// Models
import { GroupDetail } from '../models/group.model';


@Injectable({
  providedIn: 'root'
})
export class DemoGroupService extends GroupService {
  override getGroupDetail(groupId: string): Observable<GroupDetail> {
    return super.getGroupDetail(groupId).pipe(
      map(groupDetail => {
        return {
          ...groupDetail,
          users: groupDetail.users.map(user => ({
            ...user,
            surname: '*****',
            email: '****@***',
            telephone: '*****'
          }))
        };
      })
    );
  }
}
